// extracted by mini-css-extract-plugin
export default {"loader":"packages_loader__Qo-JD","actions":"packages_actions__5o1nS","virt":"packages_virt__0oWva"};